import GeneralAvailability from './availability';
import BoardCertifications from './board-certifications';
import CAQHAccess from './caqh-access';
import MDToolboxAccess from './mdtoolbox-access';
import DEACDSNumbers from './dea-cds-number';
import Degrees from './degrees';
import EducationExperience from './education-experience';
import Licenses from './licences';
import MalpracticeCoverage from './malpractice';
import Services from './services';
import CAQHInformation from './caqh-information';
import AvailableStates from './available-states';
import GeneralInfo from '../../admin/provider-detail/general-info';

const SelectedComponent = ({
  selectedScreen,
  providerId,
  navItemStatus,
  setNavItemStatus,
  refresh,
  userId,
}) => {
  switch (selectedScreen) {
    case 'generalInformation':
      return <GeneralInfo />;
    case 'CAQHInformation':
      return <CAQHInformation userId={userId} />;
    case 'education-and-experience':
      return <EducationExperience />;
    case 'services':
      return <Services />;
    case 'availability':
      return <GeneralAvailability providerId={providerId} />;
    case 'available-states':
      return <AvailableStates />;
    case 'boardCertifications':
      return <BoardCertifications refresh={refresh} userId={userId} />;
    case 'licenses':
      return <Licenses refresh={refresh} userId={userId} />;
    case 'DEACDSNumbers':
      return <DEACDSNumbers refresh={refresh} userId={userId} />;
    case 'MDToolboxAccess':
      return (
        <MDToolboxAccess
          navItemStatus={navItemStatus}
          setNavItemStatus={setNavItemStatus}
          refresh={refresh}
          userId={userId}
        />
      );
    case 'CAQHAccess':
      return (
        <CAQHAccess
          navItemStatus={navItemStatus}
          setNavItemStatus={setNavItemStatus}
          refresh={refresh}
          userId={userId}
        />
      );
    case 'degrees':
      return <Degrees refresh={refresh} userId={userId} />;
    case 'malpracticeCoverage':
      return <MalpracticeCoverage refresh={refresh} userId={userId} />;

    default:
      return <div>In Progress...</div>;
  }
};

export default SelectedComponent;
